import { GridColumn } from 'src/components/GridWrapper';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import AdjustBalanceErrorCell from 'src/sections/view_checkbook/AdjustBalanceErrorCell';
import CardDropdownCell from 'src/sections/view_checkbook/CardDropdownCell';
import BudgetAmountDollarCell from 'src/sections/view_checkbook/view_period_cell/BudgetAmountDollarCell';
import BudgetAmountPercentageDisplayCell from 'src/sections/view_checkbook/view_period_cell/BudgetAmountPercentageDisplayCell';
import EndingBalanceCell from 'src/sections/view_checkbook/view_period_cell/EndingBalanceCell';
import SpentAmountDollarCell from 'src/sections/view_checkbook/view_period_cell/SpentAmountDollarCell';
import PriceTextField from './PriceTextField';

export const useAdjustBalanceColumn = () => {
  const { t } = useViewCheckbook();
  const adjustBalanceColumn: GridColumn<any>[] = [
    {
      field: 'errors',
      title: '',
      menu: false,
      component: AdjustBalanceErrorCell,
      width: 40,
    },
    {
      field: 'code',
      title: t('GL Code'),
      filter: 'text',
      menu: false,
    },
    {
      field: 'description',
      title: t('Description'),
      filter: 'text',
      menu: false,
    },
    {
      field: 'budgetAmount',
      title: t('Forecast Amt'),
      filter: 'numeric',
      format: '{0:c2}',
      filterFormat: 'c',
      dataType: 'dollar',
      menu: false,
    },
    {
      field: 'holdAmount',
      title: t('Planned Amt'),
      filter: 'numeric',
      format: '{0:c2}',
      filterFormat: 'c',
      dataType: 'dollar',
      menu: false,
    },
    {
      field: 'committedAmount',
      title: t('Committed Amt'),
      filter: 'numeric',
      format: '{0:c2}',
      filterFormat: 'c',
      dataType: 'dollar',
      menu: false,
    },
    {
      field: 'spentAmount',
      title: t('Actualized Amt'),
      filter: 'numeric',
      format: '{0:c2}',
      filterFormat: 'c',
      dataType: 'dollar',
      component: SpentAmountDollarCell,
      menu: false,
    },
    {
      field: 'remainingBudgetAmount',
      title: `${t('Starting Balance')} $`,
      filter: 'numeric',
      format: '{0:c2}',
      component: BudgetAmountDollarCell,
      filterFormat: 'c',
      dataType: 'dollar',
      menu: false,
    },
    {
      field: 'endingBalance',
      title: `${t('Remaining Balance')} $`,
      filter: 'numeric',
      format: '{0:c2}',
      filterFormat: 'c',
      component: EndingBalanceCell,
      dataType: 'dollar',
      menu: false,
    },
    {
      field: 'remainingBudgetAmountPercentage',
      title: `${t('Remaining Balance')} %`,
      filter: 'numeric',
      filterFormat: 'p2',
      dataType: 'dollar',
      component: BudgetAmountPercentageDisplayCell,
      menu: false,
    },
    {
      field: 'card',
      title: t('Add/Subtract'),
      component: CardDropdownCell,
      menu: false,
    },
    {
      field: 'newAmount',
      title: t('Adjust Spent Amt'),
      filter: 'numeric',
      format: '{0:c2}',
      filterFormat: 'c',
      component: PriceTextField,
      dataType: 'dollar',
      menu: false,
    },
  ];
  return adjustBalanceColumn;
};

export default useAdjustBalanceColumn;
